import React from 'react';
import BaseModal, { BaseModalProps } from '../BaseModal/BaseModal';
import MultiMediaViewer from './MultiMediaViewer';
import { IMultiMediaViewerItem } from './MultiMediaViewerItem';
import { Size } from '../../../../Enums/Size.enum';

interface Props extends BaseModalProps {
	modalTitle?: string;
	files: IMultiMediaViewerItem[];
}

const MultiMediaViewerModal: React.FC<Props> = props => {
	return (
		<BaseModal
			{...props}
			title={props.modalTitle || 'base.files'}
			size={Size.XL}>
			<MultiMediaViewer files={props.files} />
		</BaseModal>
	);
};

export default MultiMediaViewerModal;
